import React from "react";
import { useDayPlan } from "../../DayPlanProvider";
import { CategoryDropdown } from "./CategoryDropdown";

interface CategoryButtonsProps {
  checkInDate?: string;
  checkOutDate?: string;
}

export const CategoryButtons: React.FC<CategoryButtonsProps> = ({
  checkInDate,
  checkOutDate,
}) => {
  const { toggleCustomItemForm, setActiveDropdown, activeDropdown } =
    useDayPlan();

  const handleCategoryClick = (type: string) => {
    if (activeDropdown === type) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(type);
    }
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="text-sm font-medium text-gray-700">DODAJ ELEMENT:</div>

      {/* Category Buttons */}
      <div className="flex flex-wrap gap-3">
        {/* Custom Item Button */}
        <button
          onClick={toggleCustomItemForm}
          className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
        >
          ✨ Dodaj Własne
        </button>

        {/* Gastronomy Dropdown */}
        <div className="relative">
          <button
            onClick={() => handleCategoryClick("gastronomy")}
            className={`px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 ${
              activeDropdown === "gastronomy"
                ? "bg-orange-600 text-white"
                : "bg-orange-100 text-orange-800 hover:bg-orange-200"
            }`}
          >
            <span>🍽️ Gastronomia</span>
            <span className="text-xs">▼</span>
          </button>

          {activeDropdown === "gastronomy" && (
            <CategoryDropdown
              categoryType="gastronomy"
              onClose={() => setActiveDropdown(null)}
            />
          )}
        </div>

        {/* Conference Dropdown */}
        <div className="relative">
          <button
            onClick={() => handleCategoryClick("conference")}
            className={`px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 ${
              activeDropdown === "conference"
                ? "bg-blue-600 text-white"
                : "bg-blue-100 text-blue-800 hover:bg-blue-200"
            }`}
          >
            <span>🎤 Konferencje</span>
            <span className="text-xs">▼</span>
          </button>

          {activeDropdown === "conference" && (
            <CategoryDropdown
              categoryType="conference"
              onClose={() => setActiveDropdown(null)}
            />
          )}
        </div>

        {/* Additional Dropdown */}
        <div className="relative">
          <button
            onClick={() => handleCategoryClick("additional")}
            className={`px-4 py-2 rounded-lg transition-colors flex items-center space-x-2 ${
              activeDropdown === "additional"
                ? "bg-green-600 text-white"
                : "bg-green-100 text-green-800 hover:bg-green-200"
            }`}
          >
            <span>⭐ Dodatki</span>
            <span className="text-xs">▼</span>
          </button>

          {activeDropdown === "additional" && (
            <CategoryDropdown
              categoryType="additional"
              onClose={() => setActiveDropdown(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
